var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h5',[_vm._v("2.4.1")]),_vm._v(" "),_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":"usermanual/editroute6a.mp4","type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }